export enum FileUploaderStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Error = 'Error',
  Canceled = 'Canceled',
}
